import { render } from "./courseDetailed.vue?vue&type=template&id=895d0f6e"
import script from "./courseDetailed.vue?vue&type=script&lang=js"
export * from "./courseDetailed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__